import ReactDOM from 'react-dom';
import Button from './Button';
import { AppContextProvider } from '../../../Services/AppContext';
import { loadDOMComponent } from '../../../helpers';

loadDOMComponent({
	selector: 'react-button',
	callback: ({ container }) => {
		const text = container.getAttribute('data-text');

		const onClick = function () {
			console.log('clicked');
		};

		ReactDOM.render(
			<AppContextProvider>
				<Button text={text} onClick={onClick} />
			</AppContextProvider>,
			container,
		);
	},
});
